import React from "react";
// import FeemonkLogo from "../../../images/hero_icon.svg";
// import ProfileIcon from "../../../images/icons/profile.svg";
// import FeemonkLogo from "../../../images/IMG_0793-removebg-preview.png";
import FeemonkLogo from "../../../images/monk_capital_logo_edit.png";
import ProfileIcon from "../../../images/icons/profile_insurefin.svg";
import DownloadIcon from "../../../images/icons/download.svg";
import styles from "./index.module.css";
import { Link } from "react-router-dom";

function Navbar() {
  return (
    <div className={styles.navbar}>
      <Link to="/mainpage">
        <img
          style={{ width: "12rem", height: "2rem" }}
          src={FeemonkLogo}
          alt=""
          className={styles.logo}
        />
      </Link>
      <div className={styles.footerRight}>
        {/* <div className={styles.downloadButton}>
          <p style={{ fontSize: "1rem", textAlign: "center" }}>Download App</p>
        </div> */}
        {/* <img
          style={{ width: "3rem", height: "3rem" }}
          src={ProfileIcon}
          alt=""
        /> */}
      </div>
    </div>
  );
}

export default Navbar;
